// extracted by mini-css-extract-plugin
export default {"buttons":"Beneficiaries_buttons__---a5"};